import { render, staticRenderFns } from "./DetailedComparisonModal.vue?vue&type=template&id=43cd770a&scoped=true"
import script from "./DetailedComparisonModal.vue?vue&type=script&lang=js"
export * from "./DetailedComparisonModal.vue?vue&type=script&lang=js"
import style0 from "./DetailedComparisonModal.vue?vue&type=style&index=0&id=43cd770a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd770a",
  null
  
)

export default component.exports